import {generateCharArray} from '../../services/aphabet';
import {useTranslation} from "react-i18next";
import {useState} from "react";

export default function AlphabetFilter({list, contentExtractor, notifyChange}) {
    const { t } = useTranslation();
    const [isNeedToShow, setNeedToShow] = useState(true);
    const [currentValue, setCurrentValue] = useState('');

    const ukAlphabet = [
        'А',
        'Б',
        'В',
        'Г',
        'Ґ',
        'Д',
        'Е',
        'Є',
        'Ж',
        'З',
        'И',
        'І',
        'Ї',
        'Й',
        'К',
        'Л',
        'М',
        'Н',
        'О',
        'П',
        'Р',
        'С',
        'Т',
        'У',
        'Ф',
        'Х',
        'Ц',
        'Ч',
        'Ш',
        'Щ',
        'Ю',
        'Я',
    ];
    function getIndexOfContents (list) {
        return list.reduce(((indexOfContent, item) => {
            return indexOfContent.add(contentExtractor(item));
        }), new Set());
    }
    const enAlphabet = generateCharArray('A', 'Z');
    const indexOfContents = getIndexOfContents(list);
    const isLetterInIndexOfContent = (letter) => indexOfContents.has(letter.toLowerCase());
    const ukIndex = ukAlphabet.filter(isLetterInIndexOfContent);
    const enIndex = enAlphabet.filter(isLetterInIndexOfContent);
    const letterClickHandler = (value) => () => {
        setCurrentValue(value);
        notifyChange(value);
    }

    return (
        <div>
            <div id="alphabet-organizations">
                <div className="alphabet-control-links js-alphabet-control-links">
                    {
                        isNeedToShow ?
                            <span onClick={() => setNeedToShow(false)} className="secondary-link">{t('organizations.alphabet.hide')}</span> :
                            <span onClick={() => setNeedToShow(true)}>{t('organizations.alphabet.show')}</span>
                    }
                </div>
                {
                    isNeedToShow &&
                    <div>
                        <ul className="alphabet flex wrap-flex">
                            <li onClick={letterClickHandler('')} className={currentValue === '' ? 'current' : ''}>{t('organizations.all')}</li>
                            { ukIndex.map(item => <li key={item} className={currentValue === item ? 'current' : ''} onClick={letterClickHandler(item)}>{item}</li>) }
                            <li className="break"/>
                            { enIndex.map(item => <li key={item} className={currentValue === item ? 'current' : ''} onClick={letterClickHandler(item)}>{item}</li>) }
                        </ul>
                    </div>
                }
            </div>
        </div>
    )
}
